import { useSelector } from 'react-redux';

import { getRulesSelector } from 'bdata-sns-shared/store/selectors/rulesSelector';

const useRules = () => useSelector(getRulesSelector) ?? {};

export default useRules;